import moment, {Moment} from "moment-timezone";
import {Time} from "../ristopub/Time";

export class TimeFromDateExtractor {
    public extractTime(date: Moment, timezone: string) {
        const mom = moment(date).tz(timezone)

        return Time.fromString(mom.format("HH:mm:ss"))
    }
}